/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React from "react";

//@Components
import ConfigData from "./config-data/ConfigData";
import Diagnostics from "./diagnostics/Diagnostics";

//@Models
import { GatewayReportProps } from "../../models";
/**
 * @component
 * GatewayReport Component
 *
 * This component is responsible for rendering the diagnostics information
 * related to the gateway. It imports and uses the Diagnostics component
 * to display the necessary data.
 *
 */
const GatewayReport: React.FC<GatewayReportProps> = ({ triggerDiagnosticQuery, gatewayType }) => {  
  return (
    <div className="pt-4">
      {gatewayType !== "alerton-compass" && <ConfigData />}
      {triggerDiagnosticQuery && <Diagnostics />}
    </div>
  );
};

export default GatewayReport;